module.exports = __webpack_public_path__ + "img/business_receive_02.8faf9bde.png";